<template>
  <main>
    <section
      class="h-auto sm:h-[500px] lg:h-[700px] xl:h-[781px] flex items-center justify-center relative"
    >
      <div class="home1">
        <div
          class="sm:absolute w-full h-full flex flex-wrap sm:flex-nowrap justify-between items-center py-[10%] sm:py-0"
        >
          <div class="w-full sm:w-1/2 flex items-center justify-center h-full">
            <div class="sm:pl-16">
              <img
                fetchpriority="high"
                src="@/assets/images/home/goutez-aux-proteines-nouvelle-vague.svg"
                alt="Goûtez aux protéines nouvelle vague"
                class="w-[95%] max-w-[480px] mx-auto mb-6 sm:mb-0 lg:w-[680px] animate__animated animate__fadeInDown"
              />
            </div>
          </div>
          <div
            class="w-full sm:w-1/2 sm:flex sm:items-center sm:justify-center h-full"
          >
            <img
              fetchpriority="high"
              src="@/assets/images/home/panneau2.png"
              class="w-[68%] max-w-[308px] mx-auto lg:w-[373px] lg:max-w-none xl:w-[421px] lg:-mt-16 animate__animated animate__zoomIn"
            />
          </div>
        </div>
        <div class="absolute bottom-36 left-0 w-full text-center">
          <img
            src="@/assets/images/home/scrolldown-min.png"
            class="w-[26px] mx-auto !cursor-pointer hidden lg:block"
            :class="{ 'animate__animated animate__bounce': isBouncing }"
            @click="scrollToSection"
          />
        </div>
      </div>
    </section>
    <section
      id="section2"
      class="home2 pt-14 sm:pt-14 lg:pt-28 pb-8 sm:pb-28 lg:pb-40 relative overflow-hidden -mt-[50px]"
    >
      <!-- Période (Figma: Du 01/05/2026 au 28/02/2027) -->
      <div
        class="inline-flex items-center justify-center rounded-[48px] bg-[#2490BE] text-white font-barlow-condensed font-bold uppercase text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-3 mt-6 sm:mt-0 mb-8 lg:mb-10"
      >
        Du 01/05/2026 au 28/02/2027
      </div>
      <!-- Titre (Figma: achetez un produit Petit Navire éligible et tentez votre chance* !) -->
      <p
        class="text-[#0D2651] font-barlow-condensed font-bold uppercase text-[30px] md:text-[36px] lg:text-[48px] leading-tight pt-2 sm:pt-4 max-w-[550px] lg:max-w-[796px] mx-auto"
      >
        achetez un produit Petit&nbsp;Navire éligible et tentez votre chance* !
      </p>
      <!-- CTA + règlement (Figma: Je tente ma chance + *Voir règlement...) -->
      <div class="flex items-center justify-center mt-6 sm:mt-8 lg:mt-10 px-4">
        <div class="flex flex-col items-center">
          <router-link to="/choice" class="block">
            <img
              src="@/assets/images/home/CTA-section2.svg"
              class="w-[74vw] sm:w-[330px] lg:w-[480px] cursor-pointer rounded-[50px] hover:opacity-95 transition-opacity"
              alt="Je tente ma chance"
            />
          </router-link>
          <p
            class="mt-4 sm:mt-5 text-[12px] sm:text-sm lg:text-base text-[#0D2651]"
          >
            *Voir règlement du jeu complet en
            <a
              href="https://oxoformdocs.fra1.digitaloceanspaces.com/6904b53d310c505cd7f8a31f/Reglement.pdf"
              target="_blank"
              rel="noopener noreferrer"
              class="underline font-bold"
              >cliquant ici</a
            >
          </p>
        </div>
      </div>
    </section>
    <section
      id="section3"
      class="home3 -mt-8 sm:-mt-10 lg:-mt-12 py-2 lg:py-16 text-white text-center relative"
    >
      <img
        src="@/assets/images/home/a-gagner.svg"
        class="w-[300px] sm:w-[380px] lg:w-[400px] object-contain max-w-[85%] mx-auto pt-[10%] sm:pt-16"
        alt="À gagner"
      />
      <!-- Deux images voyage : même grille que /form section2, images −30 %, gaps rapprochés -->
      <div
        class="block mx-auto mt-8 mb-8 w-[90%] max-w-[360px] sm:w-[80%] sm:max-w-[860px]"
      >
        <ul class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-0 items-start">
          <li class="text-center">
            <img
              src="@/assets/images/home/voyage.png"
              class="w-full max-w-[280px] lg:max-w-[390px] mx-auto rounded-2xl shadow-lg object-contain"
              alt=""
            />
            <p
              class="font-barlow-condensed font-bold text-center mt-3 sm:mt-4 whitespace-nowrap text-xl sm:text-2xl lg:text-[32px] leading-none tracking-tight px-1"
            >
              <span class="text-white">d'une valeur de </span>
              <span class="text-[#FEEFC7] uppercase font-bold">10 000€</span>
            </p>
          </li>
          <li class="text-center">
            <img
              src="@/assets/images/home/kit.svg"
              class="w-full max-w-[280px] lg:max-w-[390px] mx-auto rounded-2xl shadow-lg object-contain"
              alt=""
            />
            <div class="mt-3 sm:mt-4">
              <p
                class="font-barlow-condensed font-bold text-center whitespace-nowrap text-xl sm:text-2xl lg:text-[32px] leading-none tracking-tight px-1"
              >
                <span class="text-white">de dégustation </span>
                <span class="text-[#FEEFC7]">collector</span>
              </p>
              <p
                class="font-barlow-condensed font-bold text-[#2490BE] text-base sm:text-lg lg:text-[24px] leading-tight text-center mt-1.5 sm:mt-2"
              >
                pour vos salades et apéros !
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- Ligne 3 colonnes : crabe | CTA (Figma: Je découvre comment jouer et les dotations) | étoile -->
      <div
        class="flex justify-center items-center px-4 mt-6 sm:mt-8 mb-8 sm:mb-0 max-w-[1440px] mx-auto"
      >
        <div class="flex justify-center min-w-0 w-full">
          <router-link to="/dotations" class="block">
            <img
              src="@/assets/images/home/CTA-section3.svg"
              class="max-w-full w-full sm:w-[380px] lg:w-[520px] h-[72px] sm:h-[80px] lg:h-[92px] object-contain rounded-[50px] cursor-pointer hover:opacity-95 transition-opacity"
              alt="Je découvre comment jouer et les dotations"
            />
          </router-link>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import "animate.css";

const isVisible = ref(false);
const isVisible2 = ref(false);
const start = ref(false);
const isBouncing = ref(false);
let bounceInterval;

const scrollToSection = () => {
  const section = document.getElementById("section2");
  if (section) {
    const offset = 90;
    const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: sectionTop - offset,
      behavior: "smooth",
    });
  }
};

const startBounceAnimation = () => {
  isBouncing.value = true;
  setTimeout(() => {
    isBouncing.value = false;
  }, 1000);
};

onMounted(() => {
  setTimeout(() => {
    isVisible.value = true;
    start.value = true;
  }, 200);
  setTimeout(() => {
    isVisible2.value = true;
  }, 500);

  startBounceAnimation();
  bounceInterval = setInterval(startBounceAnimation, 30000);
});

onUnmounted(() => {
  if (bounceInterval) {
    clearInterval(bounceInterval);
  }
});
</script>
